(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flaglady-catalog-product"] && !Shopify.designMode) return;
  try {
    
function initFlagLadyCatalog() {
 const select = document.getElementById('fl-catalog-choice');
 const description = document.getElementById('fl-desc-1');
 if (!select || select.dataset.ready) return;
 select.dataset.ready = 'true';
 const sync = () => {
  const option = select.selectedOptions[0];
  const price = document.getElementById('fl-catalog-selected-price');
  if (price) price.textContent = option.dataset.price;
  if (description) description.value = select.dataset.productTitle + ' — ' + select.value;
  const sku = document.getElementById('fl-sku-1');
  if (sku) sku.value = option.dataset.sku || '';
  const image = document.getElementById('fl-catalog-main-image');
  const caption = document.getElementById('fl-catalog-image-caption');
  if (image && option.dataset.image) {
   image.removeAttribute('srcset');
   image.src = option.dataset.image;
   image.alt = option.dataset.alt || select.dataset.productTitle;
   if (option.dataset.width) image.width = Number(option.dataset.width);
   if (option.dataset.height) image.height = Number(option.dataset.height);
   if (caption) caption.textContent = image.alt;
  }
 };
 select.addEventListener('change', sync);
 sync();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFlagLadyCatalog); else initFlagLadyCatalog();
document.addEventListener('shopify:section:load', initFlagLadyCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
